<template>
  <v-app-bar app clipped-left light style="left: 0" color="white" elevation="1">
<!--    <v-app-bar-nav-icon @click="drawerChange"/>-->
    <v-toolbar-title style="color: #1976D2; font-size: 25px; font-weight: bolder">
      CARPLAZA
      <v-icon style="color: #1976D2; font-size: 30px; padding-bottom: 6px;">
        mdi-car-wrench
      </v-icon>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn @click="goToProfile" icon :color="isProfilePage ? 'primary' : ''">
      <v-icon>mdi-account</v-icon>
    </v-btn>
    <v-badge
        :content="notificationCount"
        color="red"
        overlap
        bordered
    >
      <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>
    </v-badge>
    <v-btn icon @click="logout()">
      <v-icon>mdi-logout</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  name: "AppHeader",
  data: function () {
    return {
      drawer: true,
      notificationCount: 5
    }
  },
  mounted() {
    console.log('this.$route.path', this.$route.path)

  },
  computed: {
    isProfilePage () {
      console.log('this.$route.path', this.$route.path)
      return this.$route.path === '/partner/profile'
    }
  },
  methods: {
    drawerChange () {
      this.$emit('drawerChange', '')
    },
    logout () {
      this.$store.dispatch('auth/logout')
      this.$router.push('/login')
      console.log('logout')
    },
    goToProfile () {
      if (this.isProfilePage) {
        return ''
      }
      this.$router.push('/partner/profile')
    }
  }
}
</script>

<style scoped>

</style>
